<template>
    <v-container fluid class="px-0">
        <v-row>
            <v-col cols="12" sm="6" md="12">
                <here-to-help-kicker class="mb-6"></here-to-help-kicker>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import hereToHelpKicker from '@/views/components/kickers/HereToHelpKicker'

    export default {
        components: {
            'here-to-help-kicker': hereToHelpKicker,
        }
    }
</script>
